import { apiIbtGetDataV2, apiSubmitIbtQuestionnaireV2 } from '@/resource/register'

export default Object.freeze({
  async ibtGetData() {
    try {
      const response = await apiIbtGetDataV2()
      if (response.data.code === 0 && response.data?.data) {
        return response.data.data
      }
      throw new Error(response.data?.errmsg ?? '')
    } catch (error) {
      if (error?.response?.data?.errmsg?.length > 0) {
        return new Error(error.response.data.errmsg)
      }
      return error
    }
  },
  async submitIbtQuestionnaire(form) {
    try {
      const response = await apiSubmitIbtQuestionnaireV2(form)
      if (response.data.code === 0 && response.data?.data) {
        return response.data.data
      }
      throw new Error(response.data?.errmsg ?? '')
    } catch (error) {
      if (error?.response?.data?.errmsg?.length > 0) {
        return new Error(error.response.data.errmsg)
      }
      return error
    }
  },
})
